export const SELECTION_TYPE = {
  MATCHED: 'matched',
  SELECTED: 'selected',
  CHANGED: 'changed',
  NEW: 'new',
};
